<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Редактирование организации</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form class="pt-5">
        <v-text-field
            label="Название организации"
            v-model="form.organizationName"
            type="text"
            :readonly="true"
            disabled
        />
        <v-text-field
            label="Подразделение (Филиал)"
            v-model="form.unitName"
            type="text"
            :readonly="true"
            disabled
        />

        <v-text-field
            label="Название группы (Статистика)"
            v-model="form.groupName"
            type="text"
            maxlength="200"
            :counter="200"
            hint="Задайте имя группы, если это главный филиал"
            persistent-hint
            class="mb-3"
        />

        <v-divider class="mb-5"></v-divider>

        <v-text-field
            label="ИНН"
            v-model="form.inn"
            type="text"
            maxlength="9"
            :counter="9"
        />

        <v-text-field
            v-model="form.accountNumber"
            label="Расчетный счет"
            type="text"
            maxlength="30"
            :counter="30"
        />

        <v-text-field
            v-model="form.mfo"
            label="МФО"
            type="text"
            maxlength="5"
            :counter="5"
        />

        <v-text-field
            v-model="form.contractNumber"
            label="Номер договора"
            type="text"
            maxlength="200"
        />

        <v-spacer class="py-2"></v-spacer>

        <DateInput v-model="form.contractDateFrom"
                   label="Дата договора (с)"
                   :dense="true"
                   min-width="0"
                   max-width="80%"
        />

        <v-spacer class="py-2"></v-spacer>

        <DateInput v-model="form.contractDateTo"
                   label="Дата договора (по)"
                   :dense="true"
                   min-width="0"
                   max-width="80%"
        />

        <v-spacer class="py-2"></v-spacer>

        <v-autocomplete v-model="form.contractSignerUnitId"
                        :items="units"
                        label="Филиал подписанта (Global Unit)"
                        :dense="true"
                        :clearable="true"
                        item-text="Name"
                        item-value="Id" />

        <v-snackbar v-model="isServerError"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          Произошла ошибка сервера
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="secondary" @click="onCancelButtonClicked">Отмена</v-btn>
      <v-spacer/>
      <v-btn text color="primary" @click="onSaveButtonClicked">Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import GlobalUnitService from "@/services/global.unit.service";
import ClientOrganizationService from "@/services/organization.service";

export default {
  name: "EditClientOrganizationComponent",
  components: {
    DateInput: () => import('@/components/input/DateInput.vue')
  },
  data() {
    return {
      loading: false,
      units: [],
      form: {
        id: null,
        organizationName: '',
        unitName: '',
        groupName: '', // <-- Добавлено в стейт
        inn: '',
        accountNumber: '',
        mfo: '',
        contractNumber: '',
        contractDateFrom: null,
        contractDateTo: null,
        contractSignerUnitId: null,
      },
      isServerError: false
    }
  },
  methods: {
    loadUnits() {
      GlobalUnitService.getUnits({inn: this.$store.getters.inn})
          .then(response => {
            this.units = response.data;
          });
    },
    set(organization) {
      this.clear();

      this.form.id = organization.Id || organization.id;
      this.form.organizationName = organization.OrganizationName || organization.organizationName;
      this.form.unitName = organization.UnitName || organization.unitName;
      this.form.groupName = organization.GroupName || organization.groupName || ''; // <-- Маппим при открытии
      this.form.inn = organization.Inn || organization.inn;
      this.form.accountNumber = organization.AccountNumber || organization.accountNumber;
      this.form.mfo = organization.Mfo || organization.mfo;
      this.form.contractNumber = organization.ContractNumber || organization.contractNumber;
      this.form.contractDateFrom = organization.ContractDateFrom || organization.contractDateFrom;
      this.form.contractDateTo = organization.ContractDateTo || organization.contractDateTo;

      let rawUnitId = organization.ContractSignerUnitId || organization.contractSignerUnitId;
      if (rawUnitId && typeof rawUnitId === 'object') {
        this.form.contractSignerUnitId = rawUnitId.Id || rawUnitId.id;
      } else {
        this.form.contractSignerUnitId = rawUnitId;
      }

      this.loadUnits();
    },
    clear() {
      this.form = {
        id: null,
        organizationName: '',
        unitName: '',
        groupName: '', // <-- Очищаем
        inn: '',
        accountNumber: '',
        mfo: '',
        contractNumber: '',
        contractDateFrom: null,
        contractDateTo: null,
        contractSignerUnitId: null,
      };
      this.isServerError = false;
    },
    onCancelButtonClicked() {
      this.clear();
      this.$emit('cancel');
    },
    onSaveButtonClicked() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START);
      this.isServerError = false;

      let finalUnitId = this.form.contractSignerUnitId;
      if (finalUnitId && typeof finalUnitId === 'object') {
        finalUnitId = finalUnitId.Id || finalUnitId.id;
      }

      const payload = {
        inn: this.form.inn,
        accountNumber: this.form.accountNumber,
        mfo: this.form.mfo,
        groupName: this.form.groupName, // <-- ДОБАВЛЕНО В PAYLOAD!
        contractNumber: this.form.contractNumber,
        contractDateFrom: this.form.contractDateFrom,
        contractDateTo: this.form.contractDateTo,
        contractSignerUnitId: finalUnitId
      };

      ClientOrganizationService.updateClientOrganization(this.form.id, payload)
          .then(() => {
            this.clear();
            this.$emit('updated');
          })
          .catch(() => {
            this.isServerError = true;
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    }
  }
}
</script>